<script>
import { mapState, mapGetters } from 'vuex'
export default {
	computed : {
		...mapState('auth',['currentUser','currentCompany','currentLineAccount']) ,
		...mapGetters('auth',['isLoggedIn']) ,
	}
}
</script>
